import React from 'react';

import styles from './layout.module.css';
import Menu from '../menu/menu';
import { Outlet, useLocation } from 'react-router-dom';

const NO_MENU_PAGES = ['/', '/home', '/profile-add', '/profile-interests','/profile-photos'];

const Layout = () => {
  const location = useLocation();
  const shouldShowMenu = !NO_MENU_PAGES.includes(location.pathname);

  return (
    <div className={styles.container}>
      <main className={styles.main}>        
        <Outlet />
      </main>
      {shouldShowMenu && <Menu />}
    </div>
  );
};

export default Layout;